(function ($) {
	//Languages Object
	const languages = {
		de: {
			day: 'Tag',
			days: 'Tage',
			hour: 'Stunde',
			hours: 'Stunden',
			minute: 'Minute',
			minutes: 'Minuten',
			second: 'Sekunde',
			seconds: 'Sekunden',
		},
		en: {
			day: 'Day',
			days: 'Days',
			hour: 'Hour',
			hours: 'Hours',
			minute: 'Minute',
			minutes: 'Minutes',
			second: 'Second',
			seconds: 'Seconds',
		},
		fr: {
			day: 'Jour',
			days: 'Jours',
			hour: 'Heur',
			hours: 'Heurs',
			minute: 'Minute',
			minutes: 'Minutes',
			second: 'Seconde',
			seconds: 'Secondes',
		},
		it: {
			day: 'Giorno',
			days: 'Giorni',
			hour: 'Ora',
			hours: 'Orari',
			minute: 'Minuto',
			minutes: 'Minuti',
			second: 'Secondo',
			seconds: 'Secondi',
		},
	};

	var targetIframe = document.getElementById('klaviyo-bis-iframe');
	// create an observer instance
	if (targetIframe) {
		var observerIframe = new MutationObserver(function (mutation) {
				$.each(mutation, function (index, item) {
					if (item.style.display == 'none') {
						$('html').css({
							'overflow-y': 'auto',
							position: 'static',
							width: 'initial',
							left: 'initial',
							top: 'initial',
						});
					}
				});
			}),
			configIframe = {
				attributes: true,
			};
		observerIframe.observe(targetIframe, configIframe);
	}

	//Observer to check language change and change timer text attributes
	window.MutationObserver =
		window.MutationObserver ||
		window.WebKitMutationObserver ||
		window.MozMutationObserver;
	// Find the element that you want to "watch"
	var target = document.querySelector('html'),
		// create an observer instance
		observer = new MutationObserver(function (mutation) {
			$.each(mutation, function (index, item) {
				if (target.style.position == 'fixed') {
					$(target).attr('style', '');
				}

				if (item.attributeName == 'lang' && $('.timer-banner').length > 0) {
					changeLanguage($('html').attr('lang'));
				}
			});
		}),
		config = {
			attributes: true,
		};

	observer.observe(target, config);

	var startTimer = function () {
		if ($('.timer-banner').length > 0) {
			var date = $('.timer-banner').data('date');
			var countDate = new Date(date);
			$('.timer-banner__timer').countdown({ until: countDate });
			changeLanguage($('html').attr('lang'));
		}
	};

	//Change timer language
	var changeLanguage = function (lang) {
		$('.timer-banner__timer').countdown('option', {
			labels: [
				'Years',
				'Months',
				'Weeks',
				languages[lang].days,
				languages[lang].hours,
				languages[lang].minutes,
				languages[lang].seconds,
			],
			labels1: [
				'Year',
				'Month',
				'Week',
				languages[lang].day,
				languages[lang].hour,
				languages[lang].minute,
				languages[lang].second,
			],
		});
	};

	$(document).on('click', '.menu-mobile-opener', function () {
		if (!$(this).parent().hasClass('simple')) {
			if ($(this).parent().hasClass('opened')) {
				$('.menu-mobile__item').removeClass('opened');
				$('.menu-mobile__nav').slideUp(300);
			} else {
				$('.menu-mobile__item').removeClass('opened');
				$('.menu-mobile__nav').slideUp(300);
				$(this).parent().toggleClass('opened');
				$(this).parent().find('.menu-mobile__nav').slideToggle(300);
			}
		}
	});

	//Toggle Menu
	$(document).on('click', '.hamburger', function () {
		$(this).toggleClass('ham-opened');
		$('.menu-mobile__wrapper').toggleClass('opened');
		$.scrollLock();
		$('body').toggleClass('toggle-opened');
		$('.site-header').toggleClass('site-header_white');
	});

	//Remove timer section
	$(document).on('click', '.timer-banner__close', function () {
		observer.disconnect();
		$.cookie('timer', 1, { expires: 7 });
		$('.timer-banner').remove();
		$('body').addClass('banner-removed');
		$('.site-header.with-timer.headroom').css({
			top: 0,
		});
	});

	//Check timer section and add class to body

	$('.timer-banner').ready(function () {
		startTimer();
		if ($('.timer-banner').length > 0) {
			$('body').addClass('body-with-timer');
		}
		if ($.cookie('timer') && $.cookie('timer') == 1) {
			if ($('.timer-banner').length > 0) {
				$('.timer-banner').remove();
				$('body').addClass('banner-removed');
				$('.site-header.with-timer.headroom').css({
					top: 0,
				});
			}
		} else {
			$('.timer-banner').css({
				display: 'block',
			});
		}
	});

	//Close all dropdowns when clicked outside of them
	$(document).on('click', function (event) {
		var $trigger = $(
			'' +
				'.sort-wrap-column,' +
				'.filter-wrap-column,' +
				'.rates__sort__inner,' +
				'.select__dropdown'
		);
		$.each($trigger, function (index, item) {
			if ($(item) !== event.target && !$(item).has(event.target).length) {
				$(item).removeClass('opened');
			}
		});
	});

	var resized = function () {
		if ($('.collage__wrapper').length > 0) {
			//Check Collage Size
			var items = $('.collage__wrapper .small--show');
			$.each(items, function (index, item) {
				console.log($(item).width());
				if ($(item).width() == 0) {
					$(item).css({
						'max-height': '400px',
					});
				} else {
					$(item).css({
						'max-height': $(item).width() + 'px',
					});
				}
			});
		}

		if (
			$('.tabs__collage__wrapper').length > 0 &&
			$('.tabs__collage__wrapper').parent().hasClass('tabs--tab-active')
		) {
			//Check Collage Size
			var items = $('.tabs__collage__inner .small--show');
			$.each(items, function (index, item) {
				console.log($(item).width());
				if ($(item).width() == 0) {
					$(item).css({
						'max-height': '400px',
					});
				} else {
					$(item).css({
						'max-height': $(item).width() + 'px',
					});
				}
			});
		}

		//Check elephants images
		if ($('.two-side__content').length > 0) {
			var items = $('.two-side__content');
			$.each(items, function (index, item) {
				console.log($(item).height());
				$(item)
					.parent()
					.parent()
					.find('img')
					.css({
						'max-height': $(item).height() + 150 + 'px',
					});
			});
		}

		$('.testimonial').matchHeight();
		var docWidth = $(document).width();
		if (docWidth <= 640) {
			AOS.init({
				disable: function () {
					var maxWidth = 760;
					return window.innerWidth < maxWidth;
				},
				once: true,
				offset: 50,
			});
		} else {
		}
		if (
			docWidth <= 640 &&
			!$('.blog-challenge-slide').hasClass('slick-initialized')
		) {
			//Journal Slider
			$('.blog-challenge-slide').slick({
				dots: false,
				infinite: true,
				slidesToShow: 1,
			});
		} else if (
			docWidth > 640 &&
			$('.blog-challenge-slide').hasClass('slick-initialized')
		) {
			$('.blog-challenge-slide').slick('unslick');
		}

		if (
			docWidth <= 640 &&
			!$('.most-popular__slide').hasClass('slick-initialized')
		) {
			//Journal Slider
			$('.most-popular__slide').slick({
				dots: false,
				infinite: true,
				slidesToShow: 1,
			});
		} else if (
			docWidth > 640 &&
			$('.most-popular__slide').hasClass('slick-initialized')
		) {
			$('.most-popular__slide').slick('unslick');
		}

		if (
			docWidth <= 640 &&
			!$('.journal__slider').hasClass('slick-initialized')
		) {
			//Journal Slider
			$('.journal__slider').slick({
				dots: true,
				infinite: true,
				centerPadding: '15px',
				slidesToShow: 1,
				centerMode: true,
			});
		} else if (
			docWidth > 640 &&
			$('.journal__slider').hasClass('slick-initialized')
		) {
			$('.journal__slider').slick('unslick');
		}

		if (
			docWidth <= 640 &&
			!$('.blog__three-post__slider').hasClass('slick-initialized')
		) {
			//Blog Slider
			$('.blog__three-post__slider').slick({
				dots: true,
				infinite: false,
				centerPadding: '15px',
				slidesToShow: 1,
				centerMode: true,
				adaptiveHeight: true,
			});
		} else if (
			docWidth > 640 &&
			$('.blog__three-post__slider').hasClass('slick-initialized')
		) {
			$('.blog__three-post__slider').slick('unslick');
		}
	};

	//Rotate logo function
	var rotation = function () {
		var rotation = 0,
			scrollLoc = $(document).scrollTop();
		$(window).scroll(function () {
			var newLoc = $(document).scrollTop();
			var diff = scrollLoc - newLoc;
			rotation += diff / 2;
			scrollLoc = newLoc;
			var rotationStr = 'rotate(' + rotation + 'deg)';
			$('.product-main__image-wrapper .logo-svg').css({
				'-webkit-transform': rotationStr,
				'-moz-transform': rotationStr,
				transform: rotationStr,
			});
		});
	};

	var startSliders = function () {
		//Product Main Slider
		$('.product-main__slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 8,
			slidesToScroll: 8,
			asNavFor: '.product-main__big-slider',
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 980,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 6,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 8,
						slidesToScroll: 8,
					},
				},
			],
		});

		$('.product-main__big-slider').slick({
			dots: false,
			arrows: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			speed: 500,
			asNavFor: '.product-main__slider',
		});
		//Main hero banner
		$('.hero-banner__slider').slick({
			infinite: false,
			dots: false,
			arrows: false,
			fade: true,
			autoplay: false,
			autoplaySpeed: 5000,
		});

		//Press slider
		$('.press__slider')
			.on(
				'init reInit beforeChange lazyLoaded',
				function (event, slick, currentSlide, nextSlide) {
					$(slick.$slides)
						.find('.lazyload')
						.removeClass('lazyload')
						.addClass('lazyloaded');
				}
			)
			.slick({
				infinite: true,
				dots: true,
				arrows: true,
				autoplay: false,
				autoplaySpeed: 5000,
				centerPadding: '430px',
				slidesToShow: 1,
				centerMode: true,
				responsive: [
					{
						breakpoint: 1250,
						settings: {
							slidesToScroll: 1,
							centerPadding: '200px',
						},
					},
					{
						breakpoint: 981,
						settings: {
							slidesToScroll: 1,
							centerPadding: '100px',
						},
					},
					{
						breakpoint: 641,
						settings: {
							slidesToScroll: 1,
							centerPadding: '0',
							arrows: false,
						},
					},
				],
			});

		//Testimonials slider
		$('.testimonials-slider').slick({
			infinite: true,
			dots: true,
			arrows: true,
			autoplay: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			centerPadding: '110px',
			centerMode: true,
			responsive: [
				{
					breakpoint: 851,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '55px',
						centerMode: true,
					},
				},
				{
					breakpoint: 641,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '35px',
						centerMode: true,
					},
				},
			],
		});
	};

	$(document).ready(function () {
		setTimeout(function () {
			$('.site-header').css({
				display: 'flex',
			});
		}, 400);

		$('.upsell__checkbox-wrapper').click(function () {
			$(this).find('input').trigger('click');
		});

		$('.upsell__checkbox-wrapper input').click(function (e) {
			e.stopPropagation();
		});

		$('.present__checkbox-wrapper').click(function () {
			$(this).find('input').trigger('click');
		});

		$('.present__checkbox-wrapper input').click(function (e) {
			e.stopPropagation();
		});

		if ($('.collage__wrapper').length > 0) {
			//Check Collage Size
			var items = $('.collage__wrapper .small--show');
			$.each(items, function (index, item) {
				console.log($(item).width());
				if ($(item).width() == 0) {
					$(item).css({
						'max-height': '400px',
					});
				} else {
					$(item).css({
						'max-height': $(item).width() + 'px',
					});
				}
			});
		}

		//Check elephants images
		if ($('.two-side__content').length > 0) {
			var items = $('.two-side__content');
			$.each(items, function (index, item) {
				console.log($(item).height());
				$(item)
					.parent()
					.parent()
					.find('img')
					.css({
						'max-height': $(item).height() + 150 + 'px',
					});
			});
		}

		//Sticky
		var elements = $('.sticky');
		console.log(Stickyfill.add(elements));
		Stickyfill.add(elements);

		//Disable Fancy on mobile
		if ($.fancybox.isMobile) {
			$.fancybox.destroy();
			$(document).on('click', 'a[data-fancybox]', function (e) {
				e.preventDefault();
				e.stopPropagation();
			});
		}

		$.fancybox.defaults.btnTpl.arrowLeft =
			'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
			'<div><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path d="M6 1L2 5L6 9" stroke="#000" stroke-width="2"/>\n' +
			'</svg></div>' +
			'</button>';
		$.fancybox.defaults.btnTpl.arrowRight =
			'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
			'<div><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path d="M1 9L5 5L1 1" stroke="#000" stroke-width="2"/>\n' +
			'</svg></div>' +
			'</button>';

		//Start Video
		$(document).on('click', '.article__start-image', function (e) {
			var iframe = $(this).prev().find('iframe');
			$(this).css({
				display: 'none',
			});

			$(iframe)[0].src +=
				($(iframe)[0].src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
			e.preventDefault();
		});

		//QTY Buttons
		$(document).on('click', '.qtyplus', function () {
			var input = $(this).prev();
			input.val(+input.val() + 1);
		});

		$(document).on('click', '.qtyminus', function () {
			var input = $(this).next();
			if (input.val() > 0) {
				input.val(+input.val() - 1);
			}
		});

		//Rotation Start
		rotation();

		//Height for mobile devices
		var vHeight = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vHeight + 'px');

		//Toggle Cart
		$(document).on(
			'click',
			'.cart,.mini-cart__close-button,.background-overlay',
			function () {
				$('.background-overlay').toggleClass('bg-activated');
				$('body').toggleClass('toggle-opened');
				setTimeout(function () {
					$(this).toggleClass('cart-opened');
					$('.mini-cart').toggleClass('opened');
				}, 10);
				$.scrollLock();
			}
		);

		//Toggle Popup
		// $(document).on('click','.popup--login .popup-close,.login-button',function () {
		//   $('.popup--login').toggleClass('opened');
		//   $.scrollLock()
		// })

		if (!$.cookie('newsletter-popup') && $('.popup--login').length) {
			$('.popup--login').addClass('opened');
			$.scrollLock();

			$(document).on(
				'click',
				'.popup--login .popup-close,.login-button',
				function () {
					$('.popup--login').toggleClass('opened');

					$.cookie('newsletter-popup', 1, { expires: 7 });
					$.scrollLock();
				}
			);
		}

		//Toggle Popup
		$(document).on('click', '.register-button', function () {
			$('.popup--register').toggleClass('opened');
			$.scrollLock();
		});

		//Toggle search
		$(document).on('click', '.search,.search-overlay__close', function () {
			$('.search-overlay').toggleClass('opened');
			if ($('.search-overlay').hasClass('opened')) {
				$('#Search-compact').focus();
			} else {
				$('#Search-compact').blur();
			}
			$.scrollLock();
		});

		//Modals
		$(document).on('click', '.btn--modal,.modal-close,.blocker', function () {
			console.log('cliked');
			$.scrollLock();
		});

		//Toggle filter and sort on collection
		$(document).on(
			'click',
			'.filter-wrap-column .filter-button,.filter-wrap-column svg,.filter-wrap-column .filter-close',
			function () {
				$('.filter-wrap-column').toggleClass('opened');
			}
		);
		$(document).on(
			'click',
			'.sort-wrap-column .sort-button,.sort-wrap-column svg',
			function () {
				$('.sort-wrap-column').toggleClass('opened');
			}
		);
		$(document).on('click', '.sort-wrap-column li', function (e) {
			e.stopPropagation();
			$('.sort-wrap-column').find('p').html($(this).text());
			$('.sort-wrap-column').toggleClass('opened');
		});

		$(document).on('click', '.drop-selector', function () {
			$(this).toggleClass('open');
		});

		//Video Autoplays
		$(document).on(
			'mouseleave',
			'.most-popular__list-item__wrapper a',
			function () {
				var windowWidth = $(window).width();
				if (windowWidth > 640) {
					$(this).parent().removeClass('hovered');
					if ($(this).parent().find('video').length > 0) {
						let video = $(this).parent().find('video');
						$(video)[0].pause();
					}
				}
			}
		);
		$(document).on(
			'mouseenter',
			'.most-popular__list-item__wrapper a',
			function () {
				var windowWidth = $(window).width();
				if (windowWidth > 640) {
					$(this).parent().addClass('hovered');
					if ($(this).parent().find('video').length > 0) {
						let video = $(this).parent().find('video');
						$(video)[0].play();
					}
				}
			}
		);

		//Toggle Accordion FAQ
		$(document).on('click', '.faq-accordion-line', function () {
			$(this).parent().toggleClass('opened');
			$(this).next().slideToggle(300);
		});

		$(document).on('click', 'a[href="#"]', function (e) {
			e.preventDefault();
		});

		//Start Sliders
		startSliders();

		moveScroller();

		//Resize
		resized();

		//Footer mobile accordion
		$(document).on(
			'click',
			'.site-footer__menu-wrapper .h6, .site-footer__menu-wrapper .svg',
			function () {
				var ww = $(document).width();
				if (ww < 641) {
					$(this).parent().toggleClass('opened');
					$(this).parent().find('.menu').slideToggle(300);
				}
			}
		);

		//Headroom
		var options = {
			offset: 30,
			tolerance: {
				up: 20,
				down: 10,
			},
		};

		var headroomElem = document.querySelector('header');
		var headroom = new Headroom(headroomElem, options);
		headroom.init();

		if ($('.sticky-product').length > 0) {
			var $sticked = $('.sticky-product'),
				windowWidthSticky = $(document).width();
			if ($('.headroom').hasClass('headroom--pinned')) {
				if ($('body').hasClass('body-with-timer')) {
					console.log('timer');
					if (windowWidthSticky > 1100) {
						console.log(windowWidthSticky);
						$sticked.css({
							top: '80px',
						});
					} else {
						$sticked.css({
							top: '68px',
						});
					}
				} else {
					$sticked.css({
						top: '120px',
					});
				}
			} else {
				if ($('body').hasClass('body-with-timer')) {
					console.log('timer');
					if (windowWidthSticky > 1100) {
						console.log('0');
						$sticked.css({
							top: '0',
						});
					} else {
						$sticked.css({
							top: '0',
						});
					}
				} else {
					$sticked.css({
						top: '40px',
					});
				}
			}
		}
	});

	$('.navigation__item').hover(function () {
		$(this).toggleClass('navigation__item_opened');
		$('.site-header').toggleClass('site-header_white');
	});
	$(window).resize(function () {
		resized();
	});
	$(document).resize(function () {
		resized();
	});

	function moveScroller() {
		if ($('.buy-anchor').length > 0 && $('.sticky-product').length > 0) {
			console.log('stick');

			var $anchor = $('.buy-anchor');
			var $scroller = $('.sticky-product');

			var move = function () {
				var st = $(window).scrollTop();
				var ot = $anchor.offset().top;
				var docWidth = $(document).width();
				if (st > ot) {
					if ($('.headroom').hasClass('headroom--pinned')) {
						if ($('body').hasClass('body-with-timer')) {
							if (docWidth > 1100) {
								$scroller.css({
									top: '80px',
								});
							} else {
								$scroller.css({
									top: '68px',
								});
							}
						} else {
							if (docWidth > 1100) {
								$scroller.css({
									display: 'block',
									top: '120px',
								});
							} else {
								$scroller.css({
									display: 'block',
									top: '108px',
								});
							}
						}
					} else {
						if ($('body').hasClass('body-with-timer')) {
							$scroller.css({
								display: 'block',
								top: '0',
							});
						} else {
							$scroller.css({
								display: 'block',
								top: '40px',
							});
						}
					}
				} else {
					if ($('.headroom').hasClass('headroom--pinned')) {
						if (docWidth > 1100) {
							$scroller.css({
								display: 'none',
								top: '120px',
							});
						} else {
							$scroller.css({
								display: 'none',
								top: '108px',
							});
						}
					} else {
						$scroller.css({
							display: 'none',
							top: '40px',
						});
					}
				}
			};
			$(window).scroll(move);
			move();
		}
	}

	function stickyBMSidebar() {
		var windowWidth = $(window).width(),
			bmContent = $('.main-product__flex-wrapper'),
			bmSidebar = $('.inner-wrapper--small'),
			bmContentHeight = $('.main-product-big-slide__flex-wrapper').height(),
			bmSidebarHeight = $('.product-column--small').height();
		if (
			bmSidebar.length > 0 &&
			windowWidth > 1000 &&
			bmContentHeight > bmSidebarHeight
		) {
			$('.product-column--small').css({
				'min-height':
					$('.main-product-big-slide__flex-wrapper').height() + 'px',
			});
			if (windowWidth > 1200) {
				$('.inner-wrapper--small').css({
					width: $('.product-column--small').width() - 100 + 'px',
				});
			} else {
				$('.inner-wrapper--small').css({
					width: $('.product-column--small').width() - 40 + 'px',
				});
			}
			var bmContentPos = bmContent.offset();
			if (!bmContentPos) return false;
			var bmContentH = $('.product-column--big').outerHeight(true);
			var bmSidebarH = bmSidebar.outerHeight(true);
			if ($(window).scrollTop() > bmContentPos.top) {
				bmSidebar.addClass('sticky-bm');
			} else {
				bmSidebar.removeClass('sticky-bm');
			}
			if ($(window).scrollTop() > bmContentPos.top + bmContentH - bmSidebarH) {
				bmSidebar.removeClass('sticky-bm').addClass('sticky-bm-stop');
			} else {
				bmSidebar.removeClass('sticky-bm-stop');
			}
		} else {
			bmSidebar.removeClass('sticky-bm').removeClass('sticky-bm-stop');
			$('.inner-wrapper--small').css({
				width: 'initial',
			});
			$('.product-column--small').css({
				'min-height': 'initial',
			});
		}
	}
	stickyBMSidebar();

	$(window).scroll(function () {
		stickyBMSidebar();
	});

	$(window).on('resize', function () {
		stickyBMSidebar();
	});

	$('.tile .tile__subscribe').on('click', function () {
		$(this).parents('.tile__step-1').hide().next('.tile__step-2').show();
	});

	function initAccordions() {
		var active = 'active';
		var accordionSection = '.accordion__section';
		var accordionHead = '.accordion__head';
		var accordionBody = '.accordion__body';

		$('.accordion .accordion__head').on('click', function () {
			var $this = $(this);

			$this
				.toggleClass(active)
				.closest(accordionSection)
				.toggleClass(active)
				.siblings()
				.removeClass(active)
				.find(accordionHead)
				.removeClass(active);

			$this
				.siblings(accordionBody)
				.slideToggle()
				.closest(accordionSection)
				.siblings()
				.find(accordionBody)
				.slideUp();
		});
	}

	initAccordions();

	$('.size-guide').on('click', function (event) {
		event.preventDefault();

		$('.size-guide-container').addClass('active');
	});

	$('.size-guide__close').on('click', function () {
		$('.size-guide-container').removeClass('active');
	});

	function initTabs() {
		$('.tabs__nav a').on('click', function (event) {
			event.preventDefault();

			var target = $(this).attr('href');

			$(this).parent().addClass('active').siblings().removeClass('active');

			$(target).addClass('active').siblings().removeClass('active');
		});
	}

	initTabs();

	$(document).on('click touchstart', function (event) {
		if (
			!$(event.target) === '.size-guide, .size-guide__inner' ||
			!$(event.target).closest('.size-guide, .size-guide__inner').length
		) {
			$('.size-guide-container').removeClass('active');
		}
	});

	if ($('.slider-nav').length) {
		$('.slider-nav').slick({
			infinite: true,
			asNavFor: '.slider-product',
			slidesToShow: 9,
			focusOnSelect: true,
			arrows: true,
			prevArrow: $('.slider__prev'),
			nextArrow: $('.slider__next'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 8,
					},
				},
			],
		});

		$('.slider-product').slick({
			asNavFor: '.slider-nav',
			fade: true,
			dots: true,
		});

		if ($(window).width() <= 1023) {
		}
		if ($('.reviews').length) {
			$('.reviews').slick({
				slidesToShow: 4,
				responsive: [
					{
						breakpoint: 1023,
						settings: {
							slidesToShow: 3,
							centerMode: true,
							centerPadding: '40px',
							dots: true,
							arrows: false,
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '40px',
							dots: true,
							arrows: false,
						},
					},
				],
			});
		}
	}

	if ($('.btn-play').length) {
		$('.btn-play').on('click', function () {
			$(this)
				.find('video')
				.attr({
					autoplay: 'autoplay',
					muted: 'muted',
					loop: 'loop',
				})
				.fadeIn()
				.trigger('play');
			//$(this).fadeOut();
		});

		$('.section-full .btn-play').on('click', function () {
			$(this)
				.parents('.container')
				.find('.section__image')
				.find('video')
				.attr({
					autoplay: 'autoplay',
					muted: 'muted',
					loop: 'loop',
				})
				.fadeIn()
				.trigger('play');
		});
	}
})(jQuery);
